import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import merge from "lodash-es/merge";
import {Options} from "../views/chart/chart.component";
import {FilterParams} from "./filter_form.model";


@Injectable()
export class ChartModel {
	data: Object = {};
	
	data$: Observable<any>;
	
	// Начальные настройки фильтров. Обычно пустые или { userType: 'user' }
	initFilerParams:FilterParams = <FilterParams>{
		userType : 'user',
		period   : 'day',
		type     : 'last30days'
	};
	
	// Текущие настройки фильтров. Нужны для того, чтобы можно было "передёрнуть" данные с сервера
	filterParams:FilterParams = {};
	
	// Дополнительные настройки фильтров. Нужны, если данные модели нужно всегда фильтровать.
	// Например может быть модель графика ручных платежей:
	// - initFilerParams === { userType: 'user' }
	// - filterParams === {}
	// - addFilterParams === { paidType: 'firstManual' } для графика первых ручных
	// - addFilterParams === { paidType: 'secondManual'} для графика повторных ручных
	addFilterParams:FilterParams = {};
	
	options:Options = new Options();
	
	
	getData(filterParams) {
		this.filterParams = merge({}, this.initFilerParams, filterParams, this.addFilterParams);
	}
	
	
	async refresh() {
		return this.data$ ? this.data$.toPromise() : Promise.resolve({});
	}
}
